export function useRoutePagination(
  Page?: number,
  PerPage?: 10 | 50 | 150 | 300 | 500,
) {
  const mode = 'replace'
  const route = useRoute()
  const router = useRouter()

  const setQuery = (page: number, perPage: number) =>
    nextTick(() => {
      router[unref(mode)]({
        query: {
          ...route.query,
          page: page || undefined,
          perPage: perPage || undefined,
        },
      })
    })

  return computed<any>({
    get() {
      return {
        page: +route.query.page || Page || 1,
        perPage: +route.query.perPage || PerPage || 10,
      }
    },
    set(pagination: { page: number; perPage: number }) {
      setQuery(pagination.page, pagination.perPage)
    },
  })
}
